import { motion } from "framer-motion";
import { MapPin } from "lucide-react";
import { fadeInUp, staggerContainer } from "@/lib/constants";

export const SEOLocalSection = () => {
  return (
    <section className="relative section-padding bg-slate-900/50" data-testid="seo-local-section">
      <div className="max-w-4xl mx-auto">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
          variants={staggerContainer}
        >
          <motion.div variants={fadeInUp} className="text-center">
            <div className="flex items-center justify-center gap-2 mb-4">
              <MapPin className="w-5 h-5 text-indigo-400" />
              <span className="text-indigo-400 font-medium text-sm uppercase tracking-wider">Ubicación</span>
            </div>
            <h2 className="text-3xl sm:text-4xl font-bold mb-6">
              Analista de datos en <span className="text-gradient">Murcia</span>
            </h2>
            <div className="text-slate-400 space-y-4 text-left md:text-center">
              <p>
                Ofrecemos servicios de <strong className="text-white">análisis de datos</strong> y{" "}
                <strong className="text-white">Business Intelligence</strong> para empresas en
                Murcia y toda España.
              </p>
              <p>
                Como <strong className="text-white">analista de datos en Murcia</strong>, ayudo a empresas a mejorar
                ventas, optimizar operaciones y reducir costes mediante <strong className="text-white">análisis de datos profesional</strong>.
              </p>
              <p>
                Si buscas un <strong className="text-white">consultor de datos en Murcia</strong> o necesitas
                servicios de <strong className="text-white">business intelligence en Murcia</strong>, contacta
                con nosotros para un diagnóstico gratuito de tu negocio.
              </p>
              <p>
                Nuestra <strong className="text-white">consultoría de datos</strong> está orientada a transformar
                la información de tu empresa en <strong className="text-white">decisiones rentables</strong>,
                aplicando técnicas de <strong className="text-white">análisis de datos para empresas</strong> de
                cualquier sector en <strong className="text-white">Murcia, España</strong>.
              </p>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};
